import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import ListToolBarActions from 'components/toolbar/ListToolBarActions';
import WarrantiesFilter from './WarrantiesFilter';
import { useNeedPay } from 'modules/admin';
import { useWarrantyRegistry, type WarrantyColumn } from './context/WarrantyProvider';

const WarrantiesToolBar = () => {
    const { t } = useTranslation('Warranties');
    const { auth } = useAuth();
    const { needPay } = useNeedPay();
    const state = useWarrantyRegistry();
    return (
        <div className="page-toolbar-actions mb-3">
            {hasUserAccess(auth?.user, 'prodEdit') && (
                <Button
                    size="sm"
                    variant="success"
                    onClick={() => {
                        if (!needPay()) state.setCardId(0);
                    }}
                >
                    {t('add')}
                </Button>
            )}
            <ListToolBarActions
                filters={<WarrantiesFilter />}
                onReset={() => state.setQuery({ order: 'prodName', archived: false })}
                onRefresh={state.refresh}
                columns={{
                    items: (['category', 'vendor', 'id', 'article', 'price'] as WarrantyColumn[]).map(
                        (id) => ({
                            id,
                            label: t(`fields.${id}`),
                            visible: Boolean(state.visible[id]),
                        }),
                    ),
                    onToggle: (id) => state.toggle(id as WarrantyColumn),
                }}
            />
        </div>
    );
};

export default WarrantiesToolBar;
